/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImpersonateResult
 */
export interface ImpersonateResult {
    /**
     * 
     * @type {string}
     * @memberof ImpersonateResult
     */
    redirectUrl?: string | null;
}

/**
 * Check if a given object implements the ImpersonateResult interface.
 */
export function instanceOfImpersonateResult(value: object): value is ImpersonateResult {
    return true;
}

export function ImpersonateResultFromJSON(json: any): ImpersonateResult {
    return ImpersonateResultFromJSONTyped(json, false);
}

export function ImpersonateResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImpersonateResult {
    if (json == null) {
        return json;
    }
    return {
        
        'redirectUrl': json['redirectUrl'] == null ? undefined : json['redirectUrl'],
    };
}

export function ImpersonateResultToJSON(json: any): ImpersonateResult {
    return ImpersonateResultToJSONTyped(json, false);
}

export function ImpersonateResultToJSONTyped(value?: ImpersonateResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'redirectUrl': value['redirectUrl'],
    };
}

